import React from 'react';

interface BadgeProps {
    count: number;
    variant?: 'primary' | 'secondary';
}

/**
 * Componente Badge reutilizável para exibir contadores
 * Substitui múltiplas implementações locais do mesmo componente
 */
const Badge: React.FC<BadgeProps> = ({ count, variant = 'primary' }) => {
    const baseClasses = 'ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none rounded-full';

    const variantClasses = {
        primary: count > 0 ? 'text-indigo-100 bg-indigo-600' : 'text-gray-100 bg-gray-600',
        secondary: count > 0 ? 'text-blue-100 bg-blue-600' : 'text-gray-100 bg-gray-600'
    };

    return (
        <span className={`${baseClasses} ${variantClasses[variant]}`}>
            {count}
        </span>
    );
};

export default Badge; 